/**
 * Rollout switch for the descriptive sticker captions.
 *
 * The captions are on-page text — every sticker's `alt` and the matching
 * `ImageObject` caption — on ~15,000 pack pages that already rank. Being able to
 * put the old text back with an env change and a redeploy, no code, is what makes
 * shipping them to all of those pages at once an acceptable risk.
 *
 *   NEXT_PUBLIC_IMAGE_CAPTIONS=off     legacy "<title> sticker <n>" everywhere
 *   anything else / unset              descriptive captions (the default)
 *
 * NEXT_PUBLIC_, and that prefix is load-bearing. The captions are computed
 * wherever a StickerCard renders, and that is not only the server: LoadMoreClient
 * renders appended cards in the browser, and LocalizedFeed re-renders the grid
 * client-side after the country swap. A server-only variable is `undefined` in
 * the client bundle, so `off` would have meant legacy captions on the eight
 * SSR'd cards and descriptive ones on every card after them — two shapes on one
 * page, and a hydration mismatch on the localised feeds. With the prefix, Next
 * inlines the value at build time and the server and the browser agree.
 *
 * Read from a plain env var, never from `headers()`/`cookies()`: a dynamic API
 * here would opt every route that renders a sticker out of ISR and un-cache the
 * whole catalogue. Same constraint, same reasoning as lib/seo/page-facts-flag.ts.
 *
 * Read at call time rather than module scope only so the unit test can flip it;
 * the value is fixed for the life of a deploy either way (build-time on the
 * client, process env on the server), so there is no per-request cost.
 */
export function imageCaptionsEnabled(): boolean {
  return (process.env.NEXT_PUBLIC_IMAGE_CAPTIONS ?? "").trim().toLowerCase() !== "off";
}
